<template>
  <div class="registration-page-wrap">
    <div class="reg-logo">
      <span>fotty</span>
    </div>
    <div class="container-fluid full">
      <div class="row full">
        <div class="col-md-6 backgrounded-col"></div>
        <div class="col-md-6 form-col">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginRegForm",
  data() {
    return {
      user: {
        phone: ""
      }
    };
  }
};
</script>

<style lang="scss">
.registration-page-wrap {
  position: relative;
  min-height: 100vh;
  .full {
    min-height: 100vh;
  }
  @media (max-width: 768px) {
    .backgrounded-col {
      display: none;
    }
  }
  .reg-logo {
    position: absolute;
    top: 32px;
    left: 48px;
    font-weight: 900;
    font-size: 32px;
    line-height: 40px;
    color: #fff;
    z-index: 1;
    @media (max-width: 768px) {
      display: none;
    }
  }
}

.backgrounded-col {
  background-image: url("../assets/images/reg_form_bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.reg-form-wrap {
  display: grid;
  height: 100%;

  .form {
    align-self: center;
    justify-self: center;
    text-align: center;
    max-width: 376px;
    width: 100%;
    .form-title {
      text-align: center;
      margin-bottom: 56px;
      @media (max-width: 360px) {
        margin-bottom: 20px;
      }
      h4 {
        font-weight: bold;
        font-size: 32px;
        line-height: 40px;
        text-align: center;
        color: #333333;
        margin-bottom: 8px;
      }
      .descriprion {
        font-size: 16px;
        line-height: 24px;
        color: #8e8e8e;
        span {
          display: block;
        }
      }
    }
    .phone-input {
      margin-bottom: 30px !important;
      @media (max-width: 360px) {
        margin-bottom: 20px !important;
      }
      input {
        &:not(:placeholder-shown),
        &:hover {
          letter-spacing: 1px;
        }
      }
    }
    .password-input {
      // position: relative;
    }
  }
  .submit-group {
    margin-top: 36px !important;
    .confirm-line {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .input-line {
        display: flex;
        align-items: center;
      }

      label {
        margin-bottom: 0;
      }
    }
  }
  .btn-wrap {
    button {
      width: 100%;
      padding: 16px 0;
    }
    margin-bottom: 36px;
  }
  .or-line-wrap {
    width: 100%;
    position: relative;
    height: 24px;
    margin-bottom: 12px;
    .or-line {
      height: 1px;
      width: 100%;
      background-color: #e0e0e0;
      &:after {
        content: "или";
        position: absolute;
        font-size: 16px;
        line-height: 24px;
        color: $calmColor;
        background-color: #fff;
        left: calc(50% - 20px);
        padding: 0 4px;
        top: -12px;
      }
    }
  }
  .social-reg-wrap {
    display: grid;
    grid-column-gap: 16px;
    grid-template-columns: 1fr 1fr;
    // flex-wrap: wrap;
    button {
      & ~ button {
        // margin-left:
      }
    }
  }
  .under-form {
    font-size: 16px;
    line-height: 24px;
    margin-top: 24px;
    a {
      font-weight: 500;
    }
  }
}
</style>